import debounce from 'debounce-promise'
import { Form, Formik } from 'formik'
import React from 'react'

import { InputSelect } from '@/components'
import { useAlertContext } from '@/context'
import { searchOwner } from '@/forms/CreateTicket/CreateTicket.util'
import { TicketMutations } from '@/graphql/mutations/ticket.mutations'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import { User } from '@/types/Ticket'

const debouncedSearchUser = debounce(searchOwner, 1000, { leading: true })

type Props = {
  assignee?: User
  isTicketClosed: boolean
  refetchDetails: () => void
  ticketId: number
}

export const OwnerSelection = ({ assignee, isTicketClosed, refetchDetails, ticketId }: Props) => {
  const { setAlert } = useAlertContext()
  const loadUserOptions = (inputValue) => debouncedSearchUser(inputValue)

  const { mutate } = useGraphqlMutation(TicketMutations.updateTicket(), {
    onSuccess: () => {
      refetchDetails()
      setAlert('Ticket owner updated', 'success')
    },
  })

  const handleSubmit = (values: { assigneeId: number }) => {
    mutate({
      ticket: {
        ...values,
        ticketId,
      },
    })
  }

  return (
    <Formik
      initialValues={{
        assigneeId: assignee?.id,
      }}
      onSubmit={handleSubmit}
    >
      {({ submitForm }) => {
        return (
          <Form className=" flex w-1/2 flex-row flex-wrap">
            <InputSelect
              async={true}
              className="w-full"
              defaultOptions={false}
              disabled={isTicketClosed}
              id="assigneeId"
              loadOptions={loadUserOptions}
              name="assigneeId"
              nullLabel="---"
              onChange={submitForm}
              optionValue={assignee ? { label: assignee?.fullName || '', value: assignee?.id } : undefined}
              overviewDropdown={true}
            />
          </Form>
        )
      }}
    </Formik>
  )
}
